// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListPrintModalStyles } from "@insite/content-library/Components/ProductListPrintModal";
import { mergeWithCss, modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productListPrintModalStyles.container = { gap: 12 };

productListPrintModalStyles.buttonsGridItem = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            &&& {
                margin: 12px 6px 0;
                padding: 12px 0 0;
                justify-content: space-between;
            }
        `,
    }),
};

productListPrintModalStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

productListPrintModalStyles.submitButton = {
    ...modalButtonsActionStyles.submitButton,
};

productListPrintModalStyles.productPropertiesCheckboxGridContainer = {
    gap: 8,
};
